import { render, staticRenderFns } from "./CareerAptitudeTestResultsCountCard.vue?vue&type=template&id=091a2b14&"
import script from "./CareerAptitudeTestResultsCountCard.vue?vue&type=script&lang=js&"
export * from "./CareerAptitudeTestResultsCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports